module.exports = __webpack_public_path__ + "static/media/ic_host_presenter.4f03937f.svg";